"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAppContainer = createAppContainer;

var _appcontainer = require("@whys/appcontainer");

function createAppContainer(config, context) {
  var singletons = config.singletons || [];
  return (0, _appcontainer.defineContainer)({
    singletons: singletons,
    context: context
  });
}